import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { RefreshModal } from '@components/Modals/RefreshModal';
import { Sentry } from '@config';
import {
  VERSION_CHECK_INTERVAL,
  FRONTEND_VERSION_CHECK_URL,
  APP_VERSION,
  HTTP_503_SERVICE_UNAVAILABLE,
} from '@config/const';
import { setUnavailable } from '@reducers/system';

export const CheckRemoteVersion = () => {
  const [newVersion, setNewVersion] = useState(APP_VERSION);
  const [, setLastChecked] = useState(null);
  const [, setShowNewVersion] = useState(false);
  const dispatch = useDispatch();

  function hardReloadPage() {
    window.location.reload();
  }
  if (!FRONTEND_VERSION_CHECK_URL) {
    return null;
  }
  const fetchRemoteVersion = useCallback(
    () =>
      fetch(`${FRONTEND_VERSION_CHECK_URL}?${Date.now()}`, {
        cache: 'no-store',
      })
        .then((res) => {
          if (res.ok) {
            return res.json();
          }
          return Promise.reject(res);
        })
        .then((data) => {
          setNewVersion(data.version);
          setLastChecked(new Date());
          return data.version;
        })
        .catch((response) => {
          if (
            response.status === HTTP_503_SERVICE_UNAVAILABLE &&
            response?.headers.get('X-Maintenance')
          ) {
            dispatch(setUnavailable());
          } else {
            Sentry.withScope((scope) => {
              scope.setLevel('info');

              Sentry.captureException(
                new Error('Failed to fetch frontend version.'),
                {
                  tags: { statusCode: response.status },
                }
              );
            });
          }
        }),
    []
  );

  useEffect(() => {
    fetchRemoteVersion();

    const timer = setInterval(() => {
      fetchRemoteVersion().then((version) => {
        if (version !== APP_VERSION) {
          setShowNewVersion(true);
        }
      });
    }, VERSION_CHECK_INTERVAL);
    return () => clearInterval(timer);
  }, [fetchRemoteVersion]);
  const show = newVersion !== APP_VERSION;
  return <RefreshModal show={show} onHide={() => hardReloadPage()} />;
};
